var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42801 24.0977C7.42801 12.0977 16.288 2.35768 27.428 1.86768C26.2803 1.68643 25.12 1.59615 23.958 1.59768C17.9906 1.59768 12.2677 3.96821 8.0481 8.18777C3.82853 12.4073 1.45801 18.1303 1.45801 24.0977C1.45801 30.0651 3.82853 35.788 8.0481 40.0076C12.2677 44.2272 17.9906 46.5977 23.958 46.5977C25.12 46.5992 26.2803 46.5089 27.428 46.3277C16.288 45.8277 7.42801 36.0777 7.42801 24.0977Z",
    fill: "#D6F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4678 31.8271H33.0977C33.34 31.8245 33.5715 31.7264 33.7419 31.5541C33.9122 31.3819 34.0078 31.1494 34.0078 30.9071V17.2871L19.4678 31.8271Z",
    fill: "#D6F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0877 16.3574H14.7577C14.2551 16.3574 13.8477 16.7648 13.8477 17.2674V30.9174C13.8477 31.42 14.2551 31.8274 14.7577 31.8274H33.0877C33.5902 31.8274 33.9977 31.42 33.9977 30.9174V17.2674C33.9977 16.7648 33.5902 16.3574 33.0877 16.3574Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9277 46.5977C36.3541 46.5977 46.4277 36.5241 46.4277 24.0977C46.4277 11.6712 36.3541 1.59766 23.9277 1.59766C11.5013 1.59766 1.42773 11.6712 1.42773 24.0977C1.42773 36.5241 11.5013 46.5977 23.9277 46.5977Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7379 16.6279L24.5779 25.8279C24.4934 25.9129 24.3929 25.9803 24.2822 26.0263C24.1715 26.0723 24.0528 26.096 23.933 26.096C23.8131 26.096 23.6944 26.0723 23.5837 26.0263C23.473 25.9803 23.3725 25.9129 23.2879 25.8279L14.1279 16.6679",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.a6f16ff3f7402cb07eb856f13082947d.svg";
export { ForwardRef as ReactComponent };